import {
  createFileRoute,
  useNavigate,
} from '@tanstack/react-router';

import {
  Backdrop,
  Button,
  CircularProgress,
  createTheme,
  styled,
  ThemeProvider,
  ToggleButton,
  ToggleButtonGroup,
  ToggleButtonProps,
} from '@mui/material';
import React, {
  useEffect, useState,
} from 'react';
import {
  Form,
} from 'react-bootstrap';
import {
  useAuth,
} from 'react-oidc-context';

import SpeciaLogo2Url from '#resources/images/logos/circle-specia-2.png?url';
import SpeciaLogoWithNameUrl from '#resources/images/logos/SpeciaLogoWithName.png?url';

export enum UserTypeEnum {
  owner,
  employee,
}

type UserTypeStrings = keyof typeof UserTypeEnum;
export const Route = createFileRoute('/_app/_authenticated/setup/')({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();
  const auth = useAuth();
  const [
    companyName,
    setCompanyName,
  ] = useState<string>('');
  const [
    ABN,
    setABN,
  ] = useState<string>('');
  const [
    isLoading,
    setIsLoading,
  ] = useState<boolean>(false);
  const [
    userType,
    setUserType,
  ] = useState<UserTypeEnum>(UserTypeEnum.owner);
  const [
    alignment,
    setAlignment,
  ] = React.useState('left');

  function getToggleButtonProps(
    onClick: ToggleButtonProps['onClick'],
    userType: UserTypeEnum,
  ): ToggleButtonProps {
    return {
      style: {
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        justifyContent: 'flex-end',
        padding: '1.2vw',
        border: 'none',
        borderRadius: '0.5vw',
        backgroundColor: userType === UserTypeEnum.owner
          ? 'var(--mantine-color-transparent-dark-8)'
          : 'var(--mantine-color-transparent-3)',
        marginBottom: '1vw',
        marginTop: '1vw',
      },
      onClick,
      value: UserTypeEnum[userType],
    };
  }
  const darkTheme = createTheme({
    palette: {
      mode: 'dark',
    },
  });
  const handleAlignment = (event, newAlignment) => {
    setAlignment(newAlignment);
  };
  async function nextButtonHandler() {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      if (UserTypeEnum.employee) {
        navigate({
          to: '/setup/employee',
        });
      } else if (UserTypeEnum.owner) {
        navigate({
          to: '/setup/owner',
        });
      }
    }, 300);
  }

  return (
    <div
      style={ {
        display: 'flex',
        flexDirection: 'row',
        padding: '5vh 15vw',
      } }
    >
      <div
        style={ {
          flex: 1,
        } }
      >
        <img
          src={ SpeciaLogoWithNameUrl }
          width="40%"
          style={ {
            paddingBottom: '12vh',
          } }
          alt="Specia logo"
        />
        <img
          src={ SpeciaLogo2Url }
          width="90%"
          style={ {
            paddingBottom: '15vh',
          } }
          alt="Specia logo"
        />
      </div>
      <div
        style={ {
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        } }
      >
        <div
          style={ {
            paddingLeft: '10vw',
          } }
        >
          <header>
            <p
              style={ {
                margin: '0px',
                color: 'white',
                fontSize: '1vw',
                fontWeight: 300,
              } }
            >
              <span
                style={ {
                  color: 'rgba(255, 255, 255, 0.7)',
                  fontSize: '1vw',
                } }
              >
                Welcome to
              </span>
              { ' ' }
              Specia Platform,
            </p>
            <h1
              style={ {
                fontSize: '1.5vw',
                marginBottom: '1vw',
              } }
            >
              Tell us about your role
            </h1>
            <p
              style={ {
                color: 'rgba(255, 255, 255, 0.75)',
                fontSize: '0.85vw',
                margin: 0,
              } }
            >
              Please select the option best describes your role in your organization.
            </p>
          </header>
          <ThemeProvider
            theme={ darkTheme }
          >
            <ToggleButtonGroup
              value={ alignment }
              exclusive
              onChange={ handleAlignment }
              // aria-label="text alignment"
              style={ {
                display: 'flex',
                flexDirection: 'column',
              } }
            >
              <ToggleButton
                { ...getToggleButtonProps(() => setUserType(UserTypeEnum.owner), userType) }
              >
                <div
                  style={ {
                    flex: 1,
                    textAlign: 'left',
                    textTransform: 'none',
                    color: 'rgb(255, 255, 255, 0.8)',
                  } }
                >
                  <p
                    style={ {
                      marginBottom: '0.3vw',
                      fontWeight: '600',
                      fontSize: '1.1vw',
                      color: userType === UserTypeEnum.owner ? 'rgb(0, 0, 0, 0.8)' : 'rgb(255, 255, 255, 0.8)',
                    } }
                  >
                    Owner
                  </p>
                  <p
                    style={ {
                      marginBottom: '0',
                      fontSize: '0.8vw',
                      fontWeight: '400',
                      color: userType === UserTypeEnum.owner ? 'rgb(0, 0, 0, 0.8)' : 'rgb(255, 255, 255, 0.8)',
                    } }
                  >
                    Select this option if you will be responsible for managing Specia Platform for your organization.
                  </p>
                </div>
                <div>
                  <Form.Check
                    // style={{height: '1vw', width: '1vw'}}
                    style={ {
                      cursor: 'pointer',
                      paddingLeft: '1vw',
                    } }
                    checked={ userType === UserTypeEnum.owner }
                    type="checkbox"
                  />
                </div>
              </ToggleButton>
              <ToggleButton
                { ...getToggleButtonProps(() => setUserType(UserTypeEnum.employee), userType) }
              >
                <div
                  style={ {
                    flex: 1,
                    textAlign: 'left',
                    textTransform: 'none',
                    color: 'rgb(255, 255, 255, 0.8)',
                  } }
                >
                  <p
                    style={ {
                      marginBottom: '0.3vw',
                      fontWeight: '600',
                      fontSize: '1.1vw',
                      color: userType === UserTypeEnum.employee ? 'rgb(0, 0, 0, 0.8)' : 'rgb(255, 255, 255, 0.8)',
                    } }
                  >
                    Employee
                  </p>
                  <p
                    style={ {
                      marginBottom: '0',
                      fontSize: '0.8vw',
                      fontWeight: '400',
                      color: userType === UserTypeEnum.employee ? 'rgb(0, 0, 0, 0.8)' : 'rgb(255, 255, 255, 0.8)',
                    } }
                  >
                    Select this option if you will be using Specia Platform services to perform your task.
                  </p>
                </div>
                <div
                  style={ {
                    alignContent: 'flex-start',
                  } }
                >
                  <Form.Check
                    style={ {
                      cursor: 'pointer',
                      paddingLeft: '1vw',
                    } }
                    checked={ userType === UserTypeEnum.employee }
                    type="checkbox"
                  />
                </div>
              </ToggleButton>
            </ToggleButtonGroup>
          </ThemeProvider>
          <Button
            onClick={ nextButtonHandler }
            variant="outlined"
            style={ {
              borderColor: 'rgb(255, 255, 255, 1)',
              color: 'rgb(255, 255, 255, 0.9)',
              padding: '0.7vw',
              marginBottom: '1vw',
              border: 'none',
              backgroundImage: 'linear-gradient(rgb(255, 255, 255, 0.05), rgb(10, 10, 10, 0.05)),linear-gradient(#f25252, #f25252)',
              borderRadius: '0.5vw',
              textTransform: 'none',
              fontSize: '1vw',
              fontWeight: 500,
              letterSpacing: '0.08vw',
              width: '100%',
              marginTop: '0vw',
            } }
          >
            Continue
          </Button>
          <Backdrop
            sx={ {
              color: '#fff',
              zIndex: theme => theme.zIndex.drawer + 1,
            } }
            open={ isLoading }
            onClick={ () => { setIsLoading(false); } }
          >
            <CircularProgress
              color="inherit"
            />
          </Backdrop>
          <p
            onClick={ () => auth.signoutRedirect() }
            style={ {
              fontSize: '0.8vw',
              color: 'rgb(255, 255, 255, 0.7)',
              marginTop: '1vw',
              cursor: 'pointer',
            } }
          >
            <span
              dangerouslySetInnerHTML={ {
                __html: '&larr;',
              } }
              style={ {} }
            />
            { ' ' }
            Back to Login
          </p>
        </div>
      </div>

    </div>
  );
}
